import { Variables } from 'react-relay';
import { MockResponseConfig } from '../getMockResponse';
import { mockFullLoggedInUser } from './mockFullLoggedInUser';

export const mockFullLoggedInUserWithoutSomeStats: MockResponseConfig = {
  ...mockFullLoggedInUser,
  StatsSnapshotQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          forums: {
            __typename: 'UnifiedForums',
            id: 'ari:cloud:unified-portable-profile::forums/723',
            snapshot: {
              __typename: 'UnifiedForumsSnapshot',
              id: 'ari:cloud:unified-portable-profile::forums/723/snapshot',
              acceptedAnswersCreated: 12,
              answersCreated: 11,
              articlesCreated: 93,
              likesReceived: 0,
              totalPosts: 0,
              rank: 'RISING STAR',
            },
          },
        },
      },
    },
  }),
};
